import { SubmitFeedbackRequest, SubmitFeedbackResponse } from "@interfaces";
import { _apiRequest } from "./_apiClients";

export function submitFeedback(payload: SubmitFeedbackRequest) {
  const formData = new FormData();
  formData.append("category", payload.category);
  formData.append("message", payload.message);
  if (payload.projectName) {
    formData.append("projectName", payload.projectName);
  }
  payload.mediaFiles?.forEach((file) => {
    formData.append("media", file, file.name);
  });

  return _apiRequest<SubmitFeedbackResponse>("/v1/feedback", {
    method: "POST",
    data: formData,
  });
}
